<div class="alert alert-{{type}}" role="alert">
	<span [innerHTML]="message"></span>
	<div>
		<ng-content></ng-content>
	</div>
</div>